import { RegistrationData } from '../registrationForm/registrationForm.types';
import { FieldConfig } from './registrationConfig.types';

export const DefaultRegistrationConfig = {
  id: 'default',
  countdownTimer: 900,
  startPercentage: 5,
  endPercentage: 95,
  steps: [
    {
      id: 'offer',
      disableHeader: true,
      fields: ['promoId'] as (keyof RegistrationData)[],
    },
    {
      id: 'email',
      fields: ['email'] as (keyof RegistrationData)[],
    },
    {
      id: 'password',
      fields: ['password'] as (keyof RegistrationData)[],
    },
    {
      id: 'phone',
      fields: ['phone'] as (keyof RegistrationData)[],
    },
    {
      id: 'names',
      fields: ['firstName', 'middleName'] as (keyof RegistrationData)[],
    },
    {
      id: 'lastName',
      fields: ['lastName'] as (keyof RegistrationData)[],
    },
    {
      id: 'birthDate',
      stepTitleNS: 'registration',
      stepTitleKey: 'dateOfBirthLabel',
      fields: ['birthDate'] as (keyof RegistrationData)[],
    },
    {
      id: 'address',
      fields: ['address'] as (keyof RegistrationData)[],
    },
    {
      id: 'gender',
      fields: ['gender'] as (keyof RegistrationData)[],
    },
    {
      id: 'industry',
      fields: ['industry'] as (keyof RegistrationData)[],
    },
    {
      id: 'occupation',
      fields: ['occupation'] as (keyof RegistrationData)[],
    },
    {
      id: 'terms',
      stepTitleNS: 'registration',
      stepTitleKey: 'termsPageLabel',
      stepDescriptionNS: 'registration',
      stepDescriptionKey: 'termsPageDescription',
      fields: [
        'limits',
        'marketing',
        'age',
        'terms',
        'pep',
        'fit',
      ] as (keyof RegistrationData)[],
    },
    {
      id: 'summary',
      stepTitleNS: 'registration',
      stepTitleKey: 'summaryTitleLabel',
      cta: 'Submit',
    },
  ],
  fields: {
    promoId: {
      hideGenericError: true,
    },
    email: {
      placeholderNS: 'registration',
      placeholderKey: 'emailLabel',
      footerNS: 'registration',
      footerKey: 'emailFooter',
      type: 'text',
      inputMode: 'email',
      autoComplete: 'email',
      keyboardType: 'email-address',
      textContentType: 'emailAddress',
      autoCapitalize: 'none',
    },
    password: {
      secureTextEntry: true,
      placeholderNS: 'registration',
      placeholderKey: 'passwordLabel',
      footerNS: 'registration',
      footerKey: 'passwordFooter',
      type: 'password',
      autoComplete: 'password',
      textContentType: 'password',
    },
    phone: {
      footerNS: 'registration',
      footerKey: 'phoneFooter',
      autoComplete: 'tel-national',
      textContentType: 'telephoneNumber',
      type: 'text',
      inputMode: 'tel',
    },
    firstName: {
      placeholderNS: 'registration',
      placeholderKey: 'firstNameLabel',
      footerNS: 'registration',
      footerKey: 'firstNameFooter',
      autoComplete: 'given-name',
      textContentType: 'givenName',
    },
    middleName: {
      placeholderNS: 'registration',
      placeholderKey: 'middleNameLabel',
      autoComplete: 'additional-name',
      textContentType: 'middleName',
    },
    lastName: {
      placeholderNS: 'registration',
      placeholderKey: 'lastNameLabel',
      footerNS: 'registration',
      footerKey: 'lastNameFooter',
      autoComplete: 'family-name',
      textContentType: 'familyName',
    },
    gender: {
      headerNS: 'registration',
      headerKey: 'genderTitleLabel',
      placeholderNS: 'registration',
      placeholderKey: 'genderDescriptionLabel',
    },
    industry: {
      headerNS: 'registration',
      headerKey: 'industryTitleLabel',
      placeholderNS: 'registration',
      placeholderKey: 'industryDescriptionLabel',
    },
    occupation: {
      placeholderNS: 'registration',
      placeholderKey: 'occupationLabel',
    },
    limits: {
      placeholderNS: 'registration',
      placeholderKey: 'limitsPlaceholderLabel',
    },
    marketing: {
      placeholderNS: 'registration',
      placeholderKey: 'marketingLabel',
    },
    age: {
      placeholderNS: 'registration',
      placeholderKey: 'ageLabel',
    },
    terms: {
      placeholderNS: 'registration',
      placeholderKey: 'termsLabel',
    },
    pep: {
      placeholderNS: 'registration',
      placeholderKey: 'pepLabel',
    },
    fit: {
      placeholderNS: 'registration',
      placeholderKey: 'fitLabel',
    },
  } as Record<keyof RegistrationData, FieldConfig>,
};
